var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.75H27C27.1212 0.75 27.2375 0.798089 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z",
    stroke: "#D5D7DA",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5",
    stroke: "#D5D7DA",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 31,
    height: 16,
    rx: 2,
    fill: "#155EEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11062 22.7273H6.00692L8.00977 27.6136H8.09499L10.0978 22.7273H11.9941V30H10.5027V25.2663H10.4423L8.56019 29.9645H7.54457L5.66246 25.2486H5.6021V30H4.11062V22.7273ZM19.9442 26.3636C19.9442 27.1567 19.7939 27.8314 19.4933 28.3878C19.195 28.9441 18.7878 29.3691 18.2717 29.6626C17.7579 29.9538 17.1803 30.0994 16.5387 30.0994C15.8924 30.0994 15.3124 29.9527 14.7987 29.6591C14.2849 29.3655 13.8789 28.9406 13.5806 28.3842C13.2823 27.8279 13.1332 27.1544 13.1332 26.3636C13.1332 25.5705 13.2823 24.8958 13.5806 24.3395C13.8789 23.7831 14.2849 23.3594 14.7987 23.0682C15.3124 22.7746 15.8924 22.6278 16.5387 22.6278C17.1803 22.6278 17.7579 22.7746 18.2717 23.0682C18.7878 23.3594 19.195 23.7831 19.4933 24.3395C19.7939 24.8958 19.9442 25.5705 19.9442 26.3636ZM18.3853 26.3636C18.3853 25.8499 18.3084 25.4167 18.1545 25.0639C18.003 24.7112 17.7887 24.4437 17.5117 24.2614C17.2347 24.0791 16.9104 23.9879 16.5387 23.9879C16.167 23.9879 15.8427 24.0791 15.5657 24.2614C15.2887 24.4437 15.0733 24.7112 14.9194 25.0639C14.7679 25.4167 14.6921 25.8499 14.6921 26.3636C14.6921 26.8774 14.7679 27.3106 14.9194 27.6634C15.0733 28.0161 15.2887 28.2836 15.5657 28.4659C15.8427 28.6482 16.167 28.7393 16.5387 28.7393C16.9104 28.7393 17.2347 28.6482 17.5117 28.4659C17.7887 28.2836 18.003 28.0161 18.1545 27.6634C18.3084 27.3106 18.3853 26.8774 18.3853 26.3636ZM21.987 22.7273L23.7449 28.2528H23.8123L25.5737 22.7273H27.2782L24.7711 30H22.7896L20.2789 22.7273H21.987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovFileIcon);
export default __webpack_public_path__ + "static/media/mov_file_icon.1986455757e7ca7b89693e1fd0f8e817.svg";
export { ForwardRef as ReactComponent };